// Hover state is activated on featured-images's title when the image has mouse over.
const homeFeaturedImage = document.querySelector('.homepage-block-feat-link');
if (homeFeaturedImage) {
	homeFeaturedImage.addEventListener('mouseover', () => {
		document.querySelector('.homepage-block-feat-image-title a').classList.add('hover');
	});
	homeFeaturedImage.addEventListener('mouseout', () => {
		document.querySelector('.homepage-block-feat-image-title a').classList.remove('hover');
	});
}
